import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { api, API } from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Slider } from "../ui/slider";
import { Label } from "../ui/label";

const Row = ({ label, value, items, onChange, testid }) => (
  <div className="space-y-2">
    <Label className="text-xs text-zinc-400">{label}</Label>
    <div className="flex gap-2">
      <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
        <SelectTrigger data-testid={testid} className="bg-zinc-900/60"><SelectValue /></SelectTrigger>
        <SelectContent><SelectItem value="none">Ninguno</SelectItem>{items.map((s) => <SelectItem key={s.id} value={s.id}>{s.title}</SelectItem>)}</SelectContent>
      </Select>
      <button disabled={!value} onClick={() => new Audio(`${API}/sfx/file/${value}`).play()} data-testid={`${testid}-play`}
        className="h-9 w-9 shrink-0 rounded-md border border-white/10 grid place-items-center hover:border-[#E8C47C] disabled:opacity-30"><Play className="h-3.5 w-3.5" /></button>
    </div>
  </div>
);

export const SfxPicker = ({ cfg, set }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/sfx").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-4" data-testid="sfx-picker">
      <Row label="Gancho inicial (primer segundo)" value={cfg.sfx_intro} items={items} onChange={(v) => set({ sfx_intro: v })} testid="sfx-intro-select" />
      <Row label="En cada transición de escena" value={cfg.sfx_transition} items={items} onChange={(v) => set({ sfx_transition: v })} testid="sfx-transition-select" />
      <div className="space-y-2">
        <Label className="text-xs text-zinc-400 flex justify-between">Volumen efectos <span className="font-mono-tc text-[#E8C47C]">{Math.round(cfg.sfx_volume * 100)}%</span></Label>
        <Slider data-testid="sfx-volume-slider" min={0} max={1} step={0.05} value={[cfg.sfx_volume]} onValueChange={([v]) => set({ sfx_volume: v })} />
      </div>
    </div>
  );
};
